import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class K2K3SyncConfigService {

  constructor(private http: HttpClient) { }

  /**
   * Save sync configuration data
   * Endpoint: pdf_engine_api_url + '/updateFTCSyncConfigDetails'
   */
  saveData(
    pdfEngineApiUrl: string,
    configDetails: any,
    filterParams: any,
    globalParams: any
  ): Observable<any> {
    const fp = filterParams || {};
    const gp = globalParams || {};

    const scenarioRaw = fp.scenario ?? gp.scenario ?? '';
    const scenarioNum = Number(scenarioRaw);

    const params: any = {
      tax_year: fp.tax_year || gp.tax_year || '',
      scenario: !isNaN(scenarioNum) && scenarioRaw !== '' ? scenarioNum : scenarioRaw,
      jcd_key: fp.jcd_key || gp.jcd_key || '',
      jcd_ta_key: fp.jcd_ta_key || gp.jcd_ta_key || '',
      activity_key: fp.activity_key || gp.activity_key || '',
      screen_key: fp.screen_key || gp.screen_key || '',
      screen_type: fp.screen_type || gp.screen_type || 'grid',
      is_locked: fp.is_locked || gp.is_locked || 'N',
      issue_id: fp.issue_id || gp.issue_id || '',
      issue_id_for_tx_save: fp.issue_id_for_tx_save || gp.issue_id_for_tx_save || '',
      issue_short_desc: fp.issue_short_desc || gp.issue_short_desc || '',

      sync_id: configDetails.SYNC_ID,
      sync_name: configDetails.SYNC_NAME,
      cron_exp: configDetails.CRON_EXP,
      is_active: configDetails.IS_ACTIVE,
      start_date_str: configDetails.START_DATE,
      end_date_str: configDetails.END_DATE,
      checkLockedbj: configDetails.checkLockedbj,
    };

    const url = `${pdfEngineApiUrl}/updateFTCSyncConfigDetails`;

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      withCredentials: true
    };

    return this.http.post<any>(url, JSON.stringify(params), httpOptions);
  }
}

